import { keepPreviousData, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    getRepositoryQueryKey,
    PosMicrosIntegrationPosConfiguration,
    PosMicrosIntegrationPosConfigurationGetParameters,
    useRepositoryQuery,
    useRepositoryRegistry,
} from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useAccountingCategoriesGetAllQuery = () =>
    useRepositoryQuery('accountingCategories', 'getAll', {}, { placeholderData: keepPreviousData });

export const usePosMicrosConfigurationGet = (params: PosMicrosIntegrationPosConfigurationGetParameters) =>
    useRepositoryQuery('posMicrosIntegrationPos', 'get', params, { placeholderData: keepPreviousData });

export const POS_MICROS_CONFIGURATION_DATA_QUERY_KEY = getRepositoryQueryKey('posMicrosIntegrationPos', 'get');

export interface PosMicrosConfigurationUpsertProps {
    posMicrosConfiguration: PosMicrosIntegrationPosConfiguration;
    createNewConfiguration: boolean;
}

export const usePosMicrosConfigurationUpsert = () => {
    const queryClient = useQueryClient();
    const { posMicrosIntegrationPos } = useRepositoryRegistry();

    return useMutation({
        mutationFn: async (params: PosMicrosConfigurationUpsertProps) => {
            if (params.createNewConfiguration) {
                return posMicrosIntegrationPos.create(params.posMicrosConfiguration);
            }
            return posMicrosIntegrationPos.update(params.posMicrosConfiguration);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: POS_MICROS_CONFIGURATION_DATA_QUERY_KEY });

            showSuccessAlert({ description: lt('SaveSuccessMessage') });
        },
    });
};
